<template>
  <div>
    <!--    页面标题 start -->
    <div v-web-title :data-title="$t('message.home.title')"></div>
    <!--    页面标题 end -->

    <!--    页面搜索 start  -->
    <div class="banner">
      <div class="title">
        Your promo code is: {{ flag === 1 ? '101ruawai ' : 'AXDH599' }}
      </div>
      <div class="banner-title">
        <Button type="primary" style="height: auto;" @click="toLink(flag)">
          <span class="search-button-text" style="font-size: 5rem !important;" v-if="flag === 1">
            Book a Room
          </span>
          <span class="search-button-text" style="font-size: 5rem !important;" v-if="flag === 2"> Go rent a car</span>
        </Button>
      </div>
      <!-- <div class="nav">
        <div class="item" @click="toLink(1)">
          Booking
          <img src="@/assets/img/h_item1.png" alt="" />
          <div class="item-buttom">GO →</div>
        </div>
        <div class="item" @click="toLink(2)">
          Car Rental
          <img src="@/assets/img/h_item2.png" alt="" />
          <div class="item-buttom">GO →</div>
        </div>
        <div class="item" @click="toLink(3)">
          Airport pick-up service
          <img src="@/assets/img/h_item3.png" alt="" />
          <div class="item-buttom">GO →</div>
        </div>
      </div> -->

      <!-- <div class="search-block"> -->
      <!-- <DatePicker :open="isDatePickerOpen" type="daterange"
                            :options="disabledDates"
                            placement="bottom"
                            @on-change="datePickerChange"
                            :value="datePickerValue">
                    <div class="input-block">
                        <Input ref="checkinDate" :placeholder="$t('message.home.checkinDate')"
                               class="checkin-date"
                               :value="checkinDateStr"
                               readonly
                               @on-focus="openDatePicker"
                               @on-blur="closeDatePicker"/>
                        <Input ref="checkoutDate" :placeholder="$t('message.home.checkoutDate')"
                               class="checkout-date"
                               :value="checkoutDateStr"
                               readonly
                               @on-focus="openDatePicker"
                               @on-blur="closeDatePicker"/>
                    </div>
                </DatePicker> -->
      <!-- <div class="nights">{{totalNightsStr}}</div>
                <Button type="primary" @click="searchRoom">
                    <Icon type="ios-search" size="16" color="white"></Icon>
                    <span class="search-button-text"> {{$t('message.home.search')}}</span>
                </Button> -->
      <!-- </div> -->
    </div>
    <!--    页面搜索 end  -->

    <!--      活动展示 start -->
    <!-- <Row type="flex" justify="center" class="activity-block">
			<i-col span="18" class-name="test">
				<div class="activity-title">{{$t('message.home.activityShow')}}</div>
			</i-col>
		</Row>
		<Row type="flex" justify="center">
			<i-col span="18" class-name="activity-list">

				<div v-for="activity in activityData" :key="activity.id" class="activity">
					<div class="activity-img">
						<img :src="activity.img" alt="activity.name">
					</div>
					<div class="bottom-block">
						<div class="activity-name">{{activity.name}}</div>
						<div class="start-end-time">
							<div class="time-wrapper">
								<Icon type="md-arrow-dropright-circle" size="20" color="#00C957" />
								<span>2020-06-20</span>
							</div>
							<div class="time-wrapper">
								<Icon type="md-radio-button-on" size="20" color="red" />
								<span>2020-07-20</span>
							</div>
						</div>
					</div>
				</div>

			</i-col>

		</Row> -->

    <!--      活动展示 end -->

    <!--      积分兑换 start -->
    <!-- <Row type="flex" justify="center" class="activity-block">
			<i-col span="18" class-name="test">
				<div class="activity-title">{{$t('message.home.redeemProduct')}}</div>
			</i-col>
		</Row>
		<Row type="flex" justify="center">
			<i-col span="18" class-name="score-product-list">
				<div v-for="product in redeemableProductList" :key="product.id" class="score-product">
					<img class="score-product-img" :src="product.src" :alt="product.name">
					<div class="score-product-name">{{product.name}}</div>
				</div>
			</i-col>

		</Row> -->
    <!--      积分兑换 end -->
    <LoginModal :is-show-login="isShowLoginModal" @updateShowLoginModalStatus="setIsShowLoginModal" />
  </div>
</template>

<script>
// @ is an alias to /src
import LoginModal from "@/components/LoginModal/LoginModal";

import { empty, gotoPage, urlRequest } from "../../common/common";
import moment from "moment";
import { mapMutations, mapState } from "vuex";


export default {
  name: "Home",

  data() {
    return {
      flag: Number(this.$route.query.flag),
      isShowLoginModal: false,
      // 入店日期文本
      checkinDateStr: "",
      // 离店日期文本
      checkoutDateStr: "",
      // 入住晚数文本
      totalNightsStr: "",
      // 酒店基本信息
      motelInfo: [],
      // 活动信息
      activityData: [],
      // 可积分兑换物口数据
      redeemableProductList: [],
      // 日期选择器开关
      isDatePickerOpen: false,
      // 日期选择器值
      datePickerValue: "",
      // 入住晚数
      totalNights: 0,
      // 禁用日期
      disabledDates: {
        disabledDate(date) {
          return date && moment(date).isBefore(moment().subtract(1, "d"));
        },
      },
      // 入住日期
      checkinDate: {},
      // 离店日期
      checkoutDate: {},
    };
  },
  components: {
    LoginModal,
  },
  created() {
    // 默认显示英文
    let lang = "en";
    this.$i18n.locale = lang;
    localStorage.setItem("lang", lang);
  },

  mounted() {
    console.log("lang: ", navigator.language);

    // // 从缓存获取入住和离店日期
    // this.getDatesFromStorage();
    // // 获取酒店基本信息
    // this.getMotelInfo();
    // // 获取活动信息
    // this.getActivityInfo();
    // // 获取积分兑换信息
    // this.getRedeemableProduct();
  },

  methods: {
    // 从缓存获取入住和离店日期
    getDatesFromStorage() {
      const checkinDate = localStorage.getItem("checkinDate");
      const checkoutDate = localStorage.getItem("checkoutDate");
      const today = moment().format("YYYY-MM-DD") + " 00:00:00";
      if (
        empty(checkinDate) ||
        empty(checkoutDate) ||
        moment(checkinDate).isBefore(today)
      ) {
        localStorage.setItem("checkinDate", moment().format("YYYY-MM-DD"));
        localStorage.setItem(
          "checkoutDate",
          moment().add(1, "d").format("YYYY-MM-DD")
        );
      }
      this.checkinDate = moment(localStorage.getItem("checkinDate"));
      this.checkoutDate = moment(localStorage.getItem("checkoutDate"));

      this.getCheckinDateStr();
      this.getCheckoutDateStr();
      this.getTotalNightsStr();

      console.log("check in date str: ", this.checkinDateStr);
    },

    // 入住日期文本
    getCheckinDateStr() {
      let locale = localStorage.getItem("lang");
      if (!empty(this.checkinDate)) {
        if (locale === "en") {
          this.checkinDateStr =
            "CHECK IN: " + this.checkinDate.format("YYYY-MM-DD");
        } else if (locale === "zh") {
          this.checkinDateStr =
            "入住日期: " + this.checkinDate.format("YYYY-MM-DD");
        } else {
          this.checkinDateStr = this.checkinDate.format("YYYY-MM-DD");
        }
      }
    },

    // 离店日期文本
    getCheckoutDateStr() {
      let locale = localStorage.getItem("lang");
      if (!empty(this.checkoutDate)) {
        if (locale === "en") {
          this.checkoutDateStr =
            "CHECK OUT: " + this.checkoutDate.format("YYYY-MM-DD");
        } else if (locale === "zh") {
          this.checkoutDateStr =
            "离店日期: " + this.checkoutDate.format("YYYY-MM-DD");
        } else {
          this.checkoutDateStr = this.checkoutDate.format("YYYY-MM-DD");
        }
      }
    },

    // 入住晚数文本
    getTotalNightsStr() {
      let locale = localStorage.getItem("lang");
      this.totalNights = this.checkoutDate.diff(this.checkinDate, "days");
      if (this.totalNights > 0) {
        if (locale === "en") {
          if (this.totalNights > 1) {
            this.totalNightsStr = this.totalNights + " nights";
          } else {
            this.totalNightsStr = this.totalNights + " night";
          }
        } else if (locale === "zh") {
          this.totalNightsStr = "共" + this.totalNights + "晚";
        }
      }
    },

    // 获取酒店基本信息
    getMotelInfo() {
      urlRequest({
        url: this.api.getMotelInfo,
        method: "POST",
      }).then((res) => {
        this.motelInfo = res.data.message;
        // 写入缓存
        localStorage.setItem("motelInfo", JSON.stringify(this.motelInfo));
      });
    },

    // 获取活动数据
    getActivityInfo() {
      urlRequest({
        url: this.api.getActivityList,
        method: "POST",
      }).then((res) => {
        console.log(res);
        this.activityData = res.data.msg;
      });
    },

    // 获取积分兑换信息
    getRedeemableProduct() {
      urlRequest({
        url: this.api.getRedeemableCouponList,
        method: "POST",
      }).then((res) => {
        // 获取积分物品
        const couponList = res.data.msg;
        this.redeemableProductList = couponList.filter((item) => {
          if (item.room_type === 0) {
            return item;
          }
        });
      });
    },

    // 打开日期选择器
    openDatePicker() {
      this.isDatePickerOpen = true;
      console.log("isDatePickerOpen: ", this.isDatePickerOpen);
    },

    // 关闭日期选择器
    closeDatePicker() {
      this.isDatePickerOpen = false;
      console.log("isDatePickerOpen: ", this.isDatePickerOpen);
    },

    // 日期选择器值变化
    datePickerChange(date) {
      console.log("date", date);
      this.datePickerValue = date;
      // 保存入住日期和离店日期, 计算入住晚数
      if (!empty(this.datePickerValue)) {
        this.checkinDate = moment(this.datePickerValue[0]);
        this.checkoutDate = moment(this.datePickerValue[1]);
        this.totalNights = this.checkoutDate.diff(this.checkinDate, "days");
      }
      // 获取入住、离店、入住晚数文本
      this.getCheckinDateStr();
      this.getCheckoutDateStr();
      this.getTotalNightsStr();

      // 关闭日期选择器
      this.isDatePickerOpen = false;
    },

    // 日期选择器提交
    datePickerConfirm() {
      console.log("datePickerValue: ", this.datePickerValue);
      console.log("checkinDate: ", this.checkinDate);
      console.log("checkoutDate: ", this.checkoutDate);

      // 关闭日期选择器
      this.isDatePickerOpen = false;
      // 两个日期input失去焦点
      this.$refs.checkinDate.blur();
      this.$refs.checkoutDate.blur();
    },
    // 跳转到搜索房间页面
    searchRoom() {
      // 校验入住和离店日期为空时弹出提示
      if (empty(this.checkinDate) || empty(this.checkoutDate)) {
        this.$Message.error({
          render: (h) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    fontSize: "14px",
                    fontWeight: "bold",
                  },
                },
                this.$t("message.home.searchError")
              ),
            ]);
          },
          duration: 3,
        });
        return;
      }
      // 将入住日期和离店日期写入缓存
      localStorage.setItem(
        "checkinDate",
        this.checkinDate.format("YYYY-MM-DD")
      );
      localStorage.setItem(
        "checkoutDate",
        this.checkoutDate.format("YYYY-MM-DD")
      );
      // 跳转到房间搜索页面
      gotoPage({
        path: "/RoomList",
      });
    },
    toLink(flag) {
      switch (flag) {
        case 1:
          window.open("https://hotels.cloudbeds.com/reservation/Uag5xF");
          break;
        case 2:
          window.open = ("https://toprental.co.nz/");
          break;
      }
    },
  },

  computed: {
    ...mapState([
      // 是否登录状态
      "isLogin",
      "userInfo",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/mainStyle.scss";
@import "home.scss";
</style>
